import React from 'react';
import CardHeader from '@frontend/Components/Titles/CardHeader';
import './SectionCard.css';

export interface SectionCardProps {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * SectionCard
 * A reusable white card section with a title/subtitle header row.
 * Intended for Create/Edit forms to group related inputs and tools.
 */
const SectionCard: React.FC<SectionCardProps> = ({
  title,
  subtitle,
  right,
  children,
  className = '',
}) => {
  return (
    <section className={`section-card ${className}`}>
      <div className="section-card__header">
        <div className="section-card__header-left">
          <CardHeader title={title} />
          {subtitle && <p className="section-card__subtitle">{subtitle}</p>}
        </div>
        {right && <div className="section-card__header-right">{right}</div>}
      </div>
      <div className="section-card__body">{children}</div>
    </section>
  );
};

export default SectionCard;


